import {Injectable} from '@angular/core';

import {AuthService} from 'app/core/services/auth.service';
import {NavigateAfterLoginService} from 'app/features/sign-in/services/navigate-after-login.service';

@Injectable({
    providedIn: 'root',
})
export class BeforeSignInGuard {
    constructor(
        private auth: AuthService,
        private afterLogin: NavigateAfterLoginService
    ) {}

    canActivate(): Promise<boolean> | boolean {
        if (this.auth.getCurrentUserLastValue()) {
            // in case of redirect
            return this.afterLogin.navigate(this.auth.getCurrentUserLastValue()).then(() => false);
        }
        // no user - go to sign in
        return true;
    }
}
